/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit After/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function After({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Wait/Content/Type/Content/After"
  
}) {
let eventActionDataTypeValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.type',
})
let constantData = 'after'
let aggregateData = fromAggregate.equals(eventActionDataTypeValueData, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="event_action.data.type"
 data="'after'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 onClick={onClick}
 text="After event date (appointment scheduled)"
/>
{children}
</React.Fragment>)
}